import React from 'react'

const Notfound = () => {
  return (
    <div style={{marginTop:500}}>
      <h1>Not Found</h1>
    </div>
  )
}

export default Notfound
